/**
 * Every in-app URL is built here. Hash routing keeps the bundle deployable
 * behind any static handler the Go server chooses, with no rewrite rules.
 */

import type { SearchSort } from "../api/types";

export interface SearchParams {
  readonly query?: string;
  readonly facets?: string;
  readonly tags?: readonly string[];
  readonly folders?: readonly string[];
  readonly sort?: SearchSort;
  readonly tab?: "results" | "tags" | "folders";
}

function withQuery(path: string, entries: Readonly<Record<string, string>>): string {
  const search = new URLSearchParams(entries).toString();
  return search === "" ? `#${path}` : `#${path}?${search}`;
}

export function homePath(): string {
  return "#/";
}

export function searchPath(params: SearchParams = {}): string {
  const entries: Record<string, string> = {};
  if (params.query !== undefined && params.query !== "") {
    entries["query"] = params.query;
  }
  if (params.facets !== undefined && params.facets !== "") {
    entries["facets"] = params.facets;
  }
  if (params.tags !== undefined && params.tags.length > 0) {
    entries["tags"] = params.tags.join(",");
  }
  if (params.folders !== undefined && params.folders.length > 0) {
    entries["folders"] = params.folders.join(",");
  }
  if (params.sort !== undefined) {
    entries["sort"] = params.sort;
  }
  if (params.tab !== undefined) {
    entries["tab"] = params.tab;
  }
  return withQuery("/search", entries);
}

export function notePath(noteId: string): string {
  return `#/notes/${encodeURIComponent(noteId)}`;
}

export function editNotePath(noteId: string): string {
  return `#/notes/${encodeURIComponent(noteId)}/edit`;
}

export function newNotePath(): string {
  return "#/new";
}
